export default __webpack_public_path__ + "static/media/web-development-1928238_640.649c67b8.png";